import { render, staticRenderFns } from "./ecsettingcity.vue?vue&type=template&id=4f84601f"
import script from "./ecsettingcity.vue?vue&type=script&lang=js"
export * from "./ecsettingcity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports